import { getDomain } from '../../../utils/config';
import i18n from '../../../utils/i18n';

const domain = getDomain();

export const BREADCRUMBS_LINKS = [
	{
		label: i18n.t('main:components.breadcrumbs.linkLabels.wd'),
		url: `https://www.${domain}/design/tools-software/webdesigner+`
	},
	{
		label: i18n.t('main:components.breadcrumbs.linkLabels.plecs'),
		url: `https://www.${domain}/design/tools-software/self-service-plecs-model-generator`
	},
	{
		label: i18n.t('main:components.breadcrumbs.linkLabels.eps'),
		url: `https://www.${domain}/design/tools-software/elite-power-simulator`
	},
	{
		label: i18n.t('main:components.breadcrumbs.linkLabels.fpga'),
		url: `https://www.${domain}/design/tools-software/fpga-power-tree`
	},
	{
		label: i18n.t('main:components.breadcrumbs.linkLabels.ibd'),
		url: `https://www.${domain}/design/tools-software/block-diagram`
	},
	{
		label: i18n.t('main:components.breadcrumbs.linkLabels.edt'),
		url: `https://www.${domain}/design/tools-software/evaluation-board#c3RhPSFDb25zdWx0IFNhbGVzIE9mZmljZSwhTGFzdCBTaGlwbWVudHMsIUxpZmV0aW1lLCFPYnNvbGV0ZTs=`
	}
];
